export enum ControlVariant{
  primary = "primary",
  secondary = "secondary",
  basic = "basic",
  basicActive = "basicActive"
};